export const PRODUCT_CATALOG_PATH = '/brand/product-catalog';
export const PRODUCT_CATALOG_SETTINGS_PATH =
  '/brand/product-catalog?tab=settings';

// Default number of items to show per page in the product catalog
export const DEFAULT_ITEMS_PER_PAGE = 10;
